import { createReducer, on } from "@ngrx/store";
import { liveDataModel } from "@sports-models/index";
import * as SportsbookActions from "../../../../sports/stores/sportsbook/sportsbook.actions";

export const initialState: liveDataModel = {
  sportsNav: [],
  selectedSportsNav: null,
  categories: [],
  selectedCategory: null,
  sport: [],
};

export const SportsbookLiveReducer = createReducer(
  initialState,
  // Live
  on(SportsbookActions.setLive, (state, { type, ...liveData }) => ({
    ...state,
    ...liveData,
  })),
  on(SportsbookActions.setLiveAndFetch, (state, { type, ...liveData }) => ({
    ...state,
    ...liveData,
  })),
  on(SportsbookActions.setSelectedSportsNav, (state, { type, ...selectedSportsNav }) => ({
    ...state,
    selectedSportsNav,
    categories: [],
  })),
  on(SportsbookActions.setLiveSelectedCategory, (state, { type, ...selectedCategory }) => ({
    ...state,
    selectedCategory,
  })),
  on(SportsbookActions.setLiveSelectedCategory, (state, { type, ...selectedCategory }) => ({
    ...state,
    selectedCategory,
  })),
  on(SportsbookActions.clearLive, (state) => ({
    ...state,
    ...initialState,
  })),
);
